_ = require 'underscore'
React = require 'react'
t = require('views/internal/recup-with-helpers')('canonical_board')

{
  Board
  BoardLists
  BoardName
  Card
  ErrorMessage
  List
  PlaceholderBoardTile
  TeamName
} = require 'common/components/canonical-components/canonical-board'

class LoadingCanonicalBoard extends React.Component
  displayName: 'LoadingCanonicalBoard'

  render: t.renderable ->
    t.tag PlaceholderBoardTile, { numLists: 5 }

class GenericErrorCanonicalBoard extends React.Component
  displayName: 'GenericErrorCanonicalBoard'

  render: t.renderable ->
    { errorText } = @props

    t.div '.canonical-board-error', =>
      t.tag Board, { className: 'canonical-board-error-alert-taco', hasError: true }, =>
        t.tag ErrorMessage, =>
          t.format 'generic error', { message: errorText }

class CanonicalBoardError extends React.Component
  displayName: 'ConfusedTacoCanonicalBoard'

  render: t.renderable ->
    t.div '.canonical-board-error', =>
      t.tag Board, {
        className: @props.className
        hasError: true
      }, =>
        t.tag ErrorMessage, =>
          t.formatText @props.error
        t.tag BoardLists, =>
          [3, 1, 3, 2, 1].forEach (c) ->
            t.tag List, -> _.times(c, -> t.tag Card)

class NotFoundCanonicalBoard extends React.Component
  displayName: 'NotFoundCanonicalBoard'

  render: t.renderable ->
    t.tag CanonicalBoardError, { className: 'canonical-board-error-confused-taco', error: 'board not found error' }

class NetworkErrorCanonicalBoard extends React.Component
  displayName: 'NetworkErrorCanonicalBoard'

  render: t.renderable ->
    t.tag CanonicalBoardError, { className: 'canonical-board-error-confused-taco', error: 'network error' }

class InvalidCanonicalBoard extends React.Component
  displayName: 'InvalidCardCanonicalBoard'

  render: t.renderable ->
    t.tag CanonicalBoardError, { className: 'canonical-board-error-confused-taco', error: 'invalid board error' }

class UnauthorizedCanonicalBoard extends React.Component
  displayName: 'UnauthorizedCanonicalBoard'

  render: t.renderable ->
    t.tag CanonicalBoardError, { className: 'canonical-board-error-bouncer-taco', error: 'unauthorized board error' }

class CanonicalBoard extends React.Component
  displayName: 'CanonicalBoard'

  render: t.renderable ->
    { board } = @props

    lists = board.listList.slice(0, 5)
    if lists.length == 0
      lists = [{ cardList: { length: 1 } }] # always show at least one list

    headerBgColor = if board.get('prefs').backgroundTopColor
      board.get('prefs').backgroundTopColor
    else if board.get('prefs').backgroundBrightness == 'dark'
      '#333'
    else
      'N30'

    t.div =>
      t.div '.canonical-board', =>
        t.a '.canonical-board-link', { href: board.get('url') }, =>
          t.tag Board, {
            bgColor: board.get('prefs').backgroundColor
            bgImage: board.get('prefs').backgroundImage
            headerBgColor
          }, =>
            t.tag BoardName, =>
              t.text board.get('name')
            t.tag BoardLists, =>
              board.get('structure').map (structure) =>
                t.tag List, =>
                  for j in [0...structure]
                    t.tag Card

module.exports = {
  CanonicalBoard
  GenericErrorCanonicalBoard
  InvalidCanonicalBoard
  LoadingCanonicalBoard
  NetworkErrorCanonicalBoard
  NotFoundCanonicalBoard
  UnauthorizedCanonicalBoard
}



// WEBPACK FOOTER //
// ./app/scripts/views/canonical-board/canonical-board-components.coffee